import { lazy } from 'react';
import Map from 'components/map';
import PipelinePartNumber from 'pages/Master/PipelinePartNumberMapper';
// import Privileges from 'pages/Master/PrivillegeScreen/privileges';
import RespMap from 'pages/resp-map';
import MfgLookup from 'pages/MfgLookup';
const Dashboard = lazy(() => import('pages/Dashboard'));
const SamDashboard = lazy(() => import('pages/SamDashboard'));
  const Scheduler = lazy(() => import('pages/Scheduler'));
const Expense = lazy(() => import('pages/Expense'));
const Budget = lazy(() => import('pages/Budget'));
const Users = lazy(() => import('pages/Users'));
const Zips = lazy(() => import('pages/Zips'));
const Verifications = lazy(() => import('pages/Verifications'));
const Reports = lazy(() => import('pages/Reports'));
const PlantMappers = lazy(() => import('pages/Master/PlantMappers'));
const Region = lazy(() => import('pages/Master/Region'));
const Manufactures = lazy(() => import('pages/Master/Manufactures'));
const Hqfilter = lazy(() => import('pages/Master/Hqfilter'));
const Distributors = lazy(() => import('pages/Master/Distributors'));
const TerritoryCodeMapper = lazy(
  () => import('pages/Master/TerritoryCodeMapper')
);
const DistributorRepMapper = lazy(
  () => import('pages/Master/DistributorRepMapper')
);
const GoalSettings = lazy(() => import('pages/Master/GoalSettings'));
const EndUser = lazy(() => import('pages/Master/EndUser'));
const Uploads = lazy(() => import('pages/Uploads'));
const DistributorManagerMapper = lazy(
  () => import('pages/Master/DistributorManagerMapper')
);
const NaicsLookupTool = lazy(
  () => import('pages/Master/NaicsLookup')
);
const Product = lazy(() => import('pages/Master/Product'));
const Forecast = lazy(() => import('pages/Master/Forecast'));
const Deals = lazy(() => import('pages/Deals'));
const Privileges = lazy(() => import('pages/Master/PrivillegeScreen/privileges'))

export const pages = [
  {
    path: '/dashboard',
    permissions: ['Dashboard_Read'],
    element: Dashboard
  },
  {
    path: '/samdashboard',
    permissions: ['SamDashboard_Read'],
    element: SamDashboard
  },
  {
    path: '/scheduler',
    permissions: [],
    element: Scheduler
  },
  {
    path: '/expense',
    permissions: ['Expense_Read'],
    element: Expense
  },
  {
    path: '/budget',
    permissions: ['Budget_Read', 'Budget_Write'],
    element: Budget
  },
  {
    path: '/users',
    permissions: [],
    element: Users
  },
  {
    path: '/zips',
    permissions: ['ZipRep_Read', 'ZipRep_Write'],
    element: Zips
  },
  {
    path: '/uploads',
    permissions: [],
    element: Uploads
  },
  {
    path: '/verifications',
    permissions: [],
    element: Verifications
  },
  {
    path: '/reports',
    permissions: [],
    element: Reports
  },
  {
    path: '/master/plant-mapper',
    permissions: ['Master_Read'],
    element: PlantMappers
  },
  {
    path: '/master/region-mapper',
    permissions: ['Master_Read'],
    element: Region
  },
  {
    path: '/master/manufactures',
    permissions: ['Master_Read'],
    element: Manufactures
  },
  {
    path: '/master/products',
    permissions: ['Master_Read'],
    element: Product
  },
  {
    path: '/master/forecasts',
    permissions: ['Master_Read'],
    element: Forecast
  },
  {
    path: '/master/hq-filter',
    permissions: ['Master_Read'],
    element: Hqfilter
  },
  {
    path: '/master/distributors',
    permissions: ['Master_Read'],
    element: Distributors
  },
  {
    path: '/master/dist-rep-mapper',
    permissions: ['Master_Read'],
    element: DistributorRepMapper
  },
  {
    path: '/master/goal-settings',
    permissions: ['Master_Read'],
    element: GoalSettings
  },
  {
    path: '/master/end-user-table',
    permissions: ['Master_Read'],
    element: EndUser
  },
  {
    path: '/master/territory-code-mapper',
    permissions: ['Master_Read'],
    element: TerritoryCodeMapper
  },
  {
    path: '/master/privileges',
    permissions: ['Master_Read'],
    element: Privileges
  },
  {
    path: '/master/product-family',
    permissions: ['Master_Read'],
    element: Privileges
  },
  {
    path: '/master/pipeline-part-number-mapper',
    permissions: ['Master_Read'],
    element: PipelinePartNumber
  },
  {
    path: '/map',
    permissions: ['Master_Read'],
    element: Map
  },
  {
    path: '/resp-map',
    permissions: ['Master_Read'],
    element: RespMap
  },
  {
    path: '/nav-lookup',
    permissions: ['Reports_MfgTotals'],
    element: MfgLookup
  },
  {
    path: '/master/key-mgr',
    permissions: ['Master_Read'],
    element: DistributorManagerMapper
  },
  {
    path: '/master/naics-tool',
    permissions: ['Master_Read'],
    element: NaicsLookupTool
  },
  {
    path: '/deals',
    permissions: [],
    element: Deals
  }
];
